import React, { useState } from "react";
import {
  Dialog,
  Divider,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/API_Client";
import { useEffect } from "react";
import CustomButton from "../../reusableComponents/CustomButton";
import "../analytics/analytics.css";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import {
  businessUnitRegex,
  nameRegex,
} from "../../reusableComponents/constants";

function CreateBusinessUnit({
  open,
  onClose,
  createdUnit,
  setCreatedUnit,
  selectedBusinessUnit,
  selectedCode,
  selectedDescription,
  selectedWebsiteAddress,
  selectedVersion,
  editing,
}) {
  const { addBusinessUnit, updateBusinessUnit } = useAuth();
  const [businessUnit, setBusinessUnit] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [websiteAddress, setWebsiteAddress] = useState("");
  const [codeEdited, setCodeEdited] = useState(false);

  const [validName, setValidName] = useState(true);
  const [validWebsite, setValidWebsite] = useState(true);
  const [validDescription, setValidDescription] = useState(true);

  const onSave = () => {
    addBusinessUnit(
      {
        code: code,
        name: businessUnit,
        description: description,
        websiteAddress: websiteAddress,
      },
      function (data) {
        customToast("success", "high", `Business Unit created`);
        setCreatedUnit(!createdUnit);
        handleSaveClose();
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  const onSaveChange = () => {
    updateBusinessUnit(
      selectedCode,
      {
        name: businessUnit,
        code: selectedCode,
        description: description,
        websiteAddress: websiteAddress,
        version: selectedVersion,
      },
      function (data) {
        customToast("success", "high", `Business unit updated`);
        setCreatedUnit(!createdUnit);
        handleSaveChangeClose();
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  const handleSaveClose = () => {
    setBusinessUnit("");
    setCode("");
    setDescription("");
    setWebsiteAddress("");
    onClose();
  };

  const handleSaveChangeClose = () => {
    onClose();
  };

  const handleSaveChangeCancel = (event) => {
    setBusinessUnit(selectedBusinessUnit);
    setCode(selectedCode);
    setDescription(selectedDescription);
    setWebsiteAddress(selectedWebsiteAddress);
    onClose();
  };
  const handleNameChange = (event) => {
    const newValue = event.target.value;
    setBusinessUnit(newValue);
  };

  useEffect(() => {
    const isValid = businessUnitRegex.test(businessUnit);
    if (businessUnit?.length > 0 && !isValid) setValidName(false);
    else setValidName(true);
  }, [businessUnit]);

  useEffect(() => {
    const regex = /^[a-zA-Z0-9_\- •,.'"\s✓✔\n#:+()]*$/;
    const isValid = regex.test(description);

    if (description?.length > 0 && !isValid) setValidDescription(false);
    else setValidDescription(true);
  }, [description]);

  useEffect(() => {
    const websiteRegex =
      /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/i;
    const isValid = websiteRegex.test(websiteAddress);

    if (websiteAddress?.length > 0 && !isValid) {
      setValidWebsite(false);
    } else {
      setValidWebsite(true);
    }
  }, [websiteAddress]);

  const handleCodeChange = (event) => {
    setCodeEdited(true);
    const newValue = event.target.value;
    const regex = /^[a-z_]+$/;
    const isValid = regex.test(newValue);

    if (isValid || newValue === "") setCode(newValue);
  };

  const handleWebsiteChange = (event) => {
    setWebsiteAddress(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  useEffect(() => {
    if (!codeEdited && !editing) {
      const promptedCode = businessUnit
        .replaceAll(/[^a-zA-Z0-9_\s]+/g, "")
        .replaceAll(/\s+/g, "_");
      setCode(promptedCode);
    }
  }, [businessUnit]);

  useEffect(() => {
    setBusinessUnit(selectedBusinessUnit);
    setCode(selectedCode);
    setDescription(selectedDescription);
    setWebsiteAddress(selectedWebsiteAddress);
  }, [
    selectedBusinessUnit,
    selectedCode,
    selectedDescription,
    selectedWebsiteAddress,
  ]);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setBusinessUnit("");
      setCode("");
      setDescription("");
      onClose();
    }
  };
  return (
    <div>
      <Dialog
        className="businessUnitModal"
        open={open}
        onKeyDown={handleKeyDown}
      >
        <div style={{ padding: "24px 24px 0px 24px" }}>
          <Typography
            className="SemiboldTwenty font-black-highest"
            style={{ marginBottom: "6px" }}
          >
            {!editing ? "Create Business Unit" : "Edit Business Unit"}
          </Typography>
        </div>
        <div style={{ padding: "6px 24px 0px 24px" }}>
          <Typography className="labelRegular font-black-high">
            {!editing
              ? "Create a new business unit by providing a unique name and brief description for effective organizational management"
              : "Edit business unit by editing name and description for effective organizational management"}
          </Typography>
        </div>
        <Divider style={{ margin: "16px 24px" }} />
        <div
          style={{
            overflowY: "auto",
            width: "100%",
            gap: "12px",
            display: "flex",
            flexDirection: "column",
            padding: "0px 24px 24px 24px",
          }}
        >
          <div>
            <InputLabel
              className="bodyB2RegularText"
              sx={{ color: "var(--character-title-85, rgba(0, 0, 0, 0.85))" }}
              required={true}
            >
              Business Unit
            </InputLabel>
            <OutlinedInput
              value={businessUnit}
              onChange={handleNameChange}
              className="textFieldCreate"
              size="small"
              name="businessUnit"
              style={{ width: "100%" }}
              placeholder="Enter business unit name"
              aria-describedby="outlined-title-helper-text"
            />
            {!validName && (
              <Typography
                className="error"
                style={{
                  color: "#B9232F",
                  fontSize: "10px",
                  marginTop: "3px",
                }}
              >
                <img
                  src="/assets/errorOutline.svg"
                  style={{ height: "15px", width: "12px" }}
                />{" "}
                Special characters are not allowed
              </Typography>
            )}
          </div>
          <div>
            <InputLabel
              className="bodyB2RegularText"
              sx={{ color: "var(--character-title-85, rgba(0, 0, 0, 0.85))" }}
            >
              Website Address
            </InputLabel>
            <OutlinedInput
              value={websiteAddress}
              onChange={handleWebsiteChange}
              className="textFieldCreate"
              size="small"
              name="websiteAddress"
              style={{ width: "100%" }}
              placeholder="https://"
              aria-describedby="outlined-title-helper-text"
            />
            {!validWebsite && (
              <Typography
                className="error"
                style={{
                  color: "#B9232F",
                  fontSize: "10px",
                  marginTop: "3px",
                }}
              >
                <img
                  src="/assets/errorOutline.svg"
                  style={{ height: "15px", width: "12px" }}
                />{" "}
                Enter a valid website Address
              </Typography>
            )}
          </div>
          <div>
            <InputLabel
              htmlFor="description"
              className="bodyB2RegularText"
              sx={{ color: "var(--character-title-85, rgba(0, 0, 0, 0.85))" }}
            >
              Description
            </InputLabel>

            <OutlinedInput
              value={description}
              onChange={handleDescriptionChange}
              multiline
              rows={3}
              size="small"
              placeholder="Enter business unit description"
              aria-describedby="outlined-name-helper-text"
              sx={{ width: "100%", height: "80px" }}
            />
            {!validDescription && (
              <Typography
                className="error"
                style={{
                  color: "#B9232F",
                  fontSize: "10px",
                  marginTop: "3px",
                }}
              >
                <img
                  src="/assets/errorOutline.svg"
                  style={{ height: "15px", width: "12px" }}
                />
                Special Characters are not allowed
              </Typography>
            )}
          </div>
        </div>

        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            paddingRight: "24px",
            display: "flex",
            justifyContent: "end",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <div style={{ paddingRight: "20px" }}>
            <CustomButton
              text={"Cancel"}
              type={"secondary"}
              size={"sm"}
              onClick={!editing ? handleSaveClose : handleSaveChangeCancel}
            />
          </div>
          <CustomButton
            text={!editing ? "Save" : "Save Changes"}
            type={"secondary"}
            size={"sm"}
            variant={"contained"}
            disabled={
              !validName ||
              !validDescription ||
              !validWebsite ||
              businessUnit?.length == 0 ||
              code?.length == 0
            }
            onClick={!editing ? onSave : onSaveChange}
          />
        </div>
      </Dialog>
    </div>
  );
}

export default CreateBusinessUnit;
